/* eslint complexity: 0 */
import {
  CREATE_ACCOUNT_REQUEST,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
  SET_COUNTRY_REQUEST,
  SET_EULA_LINK,
  SET_PRIVACY_POLICY,
  SET_EULA_LINK_FAILURE,
  SET_REGISTRATION_EMAIL,
  SET_EMAIL_ERROR_TEXT,
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_MISSING_ERROR_TEXT,
  SET_REGISTRATION_PASSWORD,
  SET_PASSWORD_ERROR_TEXT,
  SET_PHONE_NUMBER_ERROR_TEXT,
  SET_PHONE_NUMBER,
  TOGGLE_EULA_ACCEPTANCE,
  TOGGLE_SHOW_PASSWORD
} from 'constants/actionTypes';
import { getMessage } from '../i18n/i18nWrapper';

export const initialState = {
  apiErrorText: '',
  country: getMessage('country.US'),
  countryCode: 'US',
  email: '',
  emailErrorText: '',
  eulaErrorText: '',
  isEulaAccepted: false,
  isFetching: false,
  eulaLink: '',
  eulaId: '',
  ppLink: '',
  privacyPolicyId: '',
  firstName: '',
  firstNameErrorText: '',
  isShowingPassword: false,
  lastName: '',
  lastNameErrorText: '',
  missingInputsList: [],
  password: '',
  passwordErrorText: '',
  phoneNumber: '',
  phoneNumberErrorText: ''
};

/**
 * Registration reducer
 * @param {Object} action
 * @param {Object} state
 * @return {Boolean}
 */
const isEulaAcceptedValidation = (action, state) => {
  if (action.country !== state.country) {
    return false;
  }
  return state.isEulaAccepted;
};

/**
 * Registration reducer
 * @param {Array} missingInputsList
 * @param {String} input
 * @return {String}
 */
const missingErrorValidation = (missingInputsList, input) => {
  if (missingInputsList.includes(input)) {
    if (input === 'eula') {
      return 'eulaAgree';
    }
    return input;
  }
  return '';
};

const actionMap = {
  [CREATE_ACCOUNT_REQUEST]: function(state) {
    return {
      ...state,
      isFetching: true
    };
  },
  [CREATE_ACCOUNT_SUCCESS]: function(state) {
    return {
      ...state,
      isFetching: false
    };
  },
  [CREATE_ACCOUNT_FAILURE]: function(state, action) {
    return {
      ...state,
      apiErrorText: action.apiErrorText,
      isFetching: false
    };
  },
  [SET_COUNTRY_REQUEST]: function(state, action) {
    const isEulaAccepted = isEulaAcceptedValidation(action, state);
    return {
      ...state,
      country: action.country,
      countryCode: action.countryId,
      isEulaAccepted
    };
  },
  [SET_EULA_LINK]: function(state, action) {
    return {
      ...state,
      eulaErrorText: '',
      eulaLink: action.eulaLink,
      eulaId: action.documentId
    };
  },
  [SET_PRIVACY_POLICY]: function(state, action) {
    return {
      ...state,
      ppLink: action.ppLink,
      privacyPolicyId: action.documentId
    };
  },
  [SET_EULA_LINK_FAILURE]: function(state) {
    return {
      ...state,
      eulaErrorText: 'eulaError'
    };
  },
  [SET_REGISTRATION_EMAIL]: function(state, action) {
    return {
      ...state,
      email: action.value.trim()
    };
  },
  [SET_EMAIL_ERROR_TEXT]: function(state, action) {
    return {
      ...state,
      emailErrorText: action.emailErrorText
    };
  },
  [SET_FIRST_NAME]: function(state, action) {
    return {
      ...state,
      firstName: action.value
    };
  },
  [SET_LAST_NAME]: function(state, action) {
    return {
      ...state,
      lastName: action.value
    };
  },
  [SET_MISSING_ERROR_TEXT]: function(state, action) {
    const {missingInputsList} = action;
    const emailErrorText = missingErrorValidation(missingInputsList, 'email');
    const eulaErrorText = missingErrorValidation(missingInputsList, 'eula');
    const firstNameErrorText = missingErrorValidation(missingInputsList, 'firstName');
    const lastNameErrorText = missingErrorValidation(missingInputsList, 'lastName');
    const passwordErrorText = missingErrorValidation(missingInputsList, 'password');
    const phoneNumberErrorText = missingErrorValidation(missingInputsList, 'phoneNumber');
    return {
      ...state,
      emailErrorText,
      eulaErrorText,
      firstNameErrorText,
      lastNameErrorText,
      passwordErrorText,
      phoneNumberErrorText
    };
  },
  [SET_REGISTRATION_PASSWORD]: function(state, action) {
    return {
      ...state,
      password: action.value
    };
  },
  [SET_PASSWORD_ERROR_TEXT]: function(state, action) {
    return {
      ...state,
      passwordErrorText: action.passwordErrorText
    };
  },
  [SET_PHONE_NUMBER_ERROR_TEXT]: function(state, action) {
    return {
      ...state,
      phoneNumberErrorText: action.phoneNumberErrorText
    };
  },
  [SET_PHONE_NUMBER]: function(state, action) {
    const phoneNumber = action.value.split('').filter((curr) => {
      return curr >= '0' && curr <= '9' || curr === '-' || curr === '+';
    }).join('');
    return {
      ...state,
      phoneNumber
    };
  },
  [TOGGLE_EULA_ACCEPTANCE]: function(state) {
    return {
      ...state,
      isEulaAccepted: !state.isEulaAccepted
    };
  },
  [TOGGLE_SHOW_PASSWORD]: function(state) {
    return {
      ...state,
      isShowingPassword: !state.isShowingPassword
    };
  }
};

/**
 * Registration reducer
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export default function registrationReducer(state = initialState, action) {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }
  return state;
}
